import { Component, inject } from '@angular/core';
import { ToastService } from 'src/app/core/providers/toast/toast.service';
import { Toast } from 'src/app/core/providers/toast/toast.models';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-toasts',
	standalone: true,
	imports: [CommonModule, NgbToastModule],
	template: `
		@for (toast of toastService.toasts; track toast) {
				<ngb-toast
					[class]="toast.classname"
					[autohide]="toast.autohide ?? true"
					[delay]="toast.delay || 5000"
					(hidden)="toast.onHidden?.(); toastService.remove(toast)"
				>
					<div class="d-flex align-items-start gap-3">
						<div class="flex-grow-1">
							<p class="mb-0" [innerHTML]="toast.message"></p>
						</div>
						<button
							*ngIf="toast.actionLabel && toast.onAction"
							type="button"
							class="btn btn-sm"
							[class]="toast.actionClassname || 'btn-dark text-white'"
							(click)="toast.onAction(); toastService.remove(toast)"
						>
							{{ toast.actionLabel }}
						</button>
						<button
							type="button"
							class="toast-close"
							aria-label="Fermer"
							(click)="closeToast(toast)"
						>
							<i class="fas fa-times"></i>
						</button>
					</div>
				</ngb-toast>
			}
		`,
	styles: [
		`
			.toast-close {
				flex-shrink: 0;
				padding: 0;
				border: 0;
				background: transparent;
				color: inherit;
				opacity: 0.55;
				line-height: 1;
				cursor: pointer;
				transition: opacity 0.15s ease;
			}
			.toast-close:hover {
				opacity: 1;
			}
		`,
	],
	host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastsContainer {
	toastService = inject(ToastService);

	closeToast(toast: Toast): void {
		toast.onHidden?.();
		this.toastService.remove(toast);
	}
}
